// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ct-additional-info-step .additional-info-form {
  display: flex;
  justify-content: center;
}
.ct-additional-info-step .additional-info-form form {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 3rem;
}
.ct-additional-info-step .additional-info-form form div.writer-name {
  width: 60rem;
  margin-top: 5rem;
}
.ct-additional-info-step .additional-info-form form div.supplemental-info {
  width: 60rem;
  margin-top: 2rem;
}
.ct-additional-info-step .additional-info-form form div.effective-date {
  width: 60rem;
}
.ct-additional-info-step .additional-info-form form div h5 {
  text-align: center;
  line-height: 22.5px;
  margin-bottom: 1.5rem;
}
.ct-additional-info-step .additional-info-form form div .input-text-form-component {
  width: 100%;
}
.ct-additional-info-step .additional-info-form form div .input-text-form-component .react-datepicker-wrapper {
  width: 100%;
}
.ct-additional-info-step .additional-info-form form div .input-text-form-component textarea {
  width: 100%;
  min-height: 8rem;
  resize: none;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/AdditionalInfoStep/index.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,uBAAA;AAAJ;AAEI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;AAAN;AAGQ;EACE,YAAA;EACA,gBAAA;AADV;AAIQ;EACE,YAAA;EACA,gBAAA;AAFV;AAKQ;EACE,YAAA;AAHV;AAMQ;EACE,kBAAA;EACA,mBAAA;EACA,qBAAA;AAJV;AAOQ;EACE,WAAA;AALV;AAOU;EACE,WAAA;AALZ;AAQU;EACE,WAAA;EACA,gBAAA;EACA,YAAA;AANZ","sourcesContent":[".ct-additional-info-step {\n  .additional-info-form {\n    display: flex;\n    justify-content: center;\n\n    form {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      margin-bottom: 3rem;\n\n      div {\n        &.writer-name {\n          width: 60rem;\n          margin-top: 5rem;\n        }\n\n        &.supplemental-info {\n          width: 60rem;\n          margin-top: 2rem;\n        }\n\n        &.effective-date {\n          width: 60rem;\n        }\n\n        h5 {\n          text-align: center;\n          line-height: 22.5px;\n          margin-bottom: 1.5rem;\n        }\n\n        .input-text-form-component {\n          width: 100%;\n\n          .react-datepicker-wrapper {\n            width: 100%;\n          }\n\n          textarea {\n            width: 100%;\n            min-height: 8rem;\n            resize: none;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
